var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.page.fields)?_c('main',{class:_vm.$style.view},[_c('h2',{class:_vm.$style.title,domProps:{"innerHTML":_vm._s(_vm.page.fields.title)}}),_c('base-bodytext',{class:_vm.$style.body,attrs:{"text":_vm.page.fields.body}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }